import axios from 'axios';

import buildQuery from 'odata-query';
import { IRequestConfig, MethodsTypes } from 'models/Axios';
import { IUserFile } from 'models/UserFile';
import store from 'store';
import Services from './index.service';

export default class UserFileServices extends Services<any, any> {
  /**
   * Function to get a limited qtd of items
   * @currentPage Range to skip, you need only pass currentPage (ex: currentPage = 1)
   * @pageSize Range to take, you need only pass pageSize (ex: pageSize = 15)
   */

  get = (
    currentPage?: number,
    pageSize?: number,
    orderby?: string,
    filter?: {}
  ) => {
    const { customer } = store.getState();
    const skip = currentPage || 0;
    const top = pageSize || 20;
    const order = orderby ? `${orderby}` : undefined;
    const filterQuery = buildQuery({
      filter: { ...filter, customerId: customer?.id },
    });

    const config: IRequestConfig<IUserFile> = {
      url: `/filesUser${filterQuery}`,
      params: {
        $top: `${top}`,
        $skip: `${skip * top}`,
        $orderby: order,
      },
    };

    return this.httpRequest(config);
  };

  create = (data: IUserFile) => {
    const config: IRequestConfig<IUserFile> = {
      url: `${this.base_url}/filesUser`,
      method: MethodsTypes.post,
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      },
      data: {
        ...data,
      },
    };

    return axios(config);
  };

  update = (data: any) => {
    const config: IRequestConfig<IUserFile> = {
      url: `${this.base_url}/filesUser`,
      method: MethodsTypes.put,
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      },
      data: {
        ...data,
      },
    };

    return axios(config);
  };

  delete = (id: string) => {
    const config: IRequestConfig<IUserFile> = {
      url: `${this.base_url}/filesUser/${id}`,
      method: MethodsTypes.delete,
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      },
    };

    return axios(config);
  };
}
